import React from "react";

import DeleteIcon from "@/icons/delete.svg";
// import Button from "@/components/Button";
// import { ReactComponent as ReplyIcon } from "@/icons/reply.svg"
import { CommentBoxInterface } from "@/helpers/pageHelpers/Common/interface";
import { formatCommentDate } from "@/helpers/formatCommentDate";
import IconButton from "@/components/IconButton";

import styles from "../Comments.module.scss";

export const CommentBox: React.FC<CommentBoxInterface> = ({
  message,
  displayName,
  createdAt,
  belongsToUser,
  removeComment,
  id,
}) => {
  const removeUserComment = async () => {
    await removeComment(id);
  };

  return (
    <div className={styles.commentBox}>
      <div className={styles.comment}>
        <div className={styles.meta}>
          <span className={styles.name}>{displayName}</span>

          <time dateTime={createdAt} className={styles.date}>
            {formatCommentDate(createdAt)}
          </time>
        </div>

        <div className={styles.commentText}>{message}</div>
        {/* @todo: Use when we got 2nd level comments from API */}
        {/*<div className={styles.actions}>*/}
        {/*  <Button variant="tertiary">*/}
        {/*    <ReplyIcon />*/}

        {/*    <span className={styles.showReply}>*/}
        {/*      Pokaż odpowiedzi (12)*/}
        {/*    </span>*/}
        {/*  </Button>*/}
        {/*</div>*/}
      </div>

      {belongsToUser && (
        <IconButton className={styles.remove} onClick={removeUserComment}>
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

export default CommentBox;
